import { atom } from 'jotai'

export interface ModalState {
  categoryModal: {
    open: boolean
    categoryId?: string
  }
}

const initialModalState: ModalState = {
  categoryModal: {
    open: false,
    categoryId: undefined
  }
}



/**
 * Container base. NOT exported from the `@/atoms` barrel on purpose: callers
 * talk to the derived atom below, which knows the state shape.
 */
const modalAtom = atom<ModalState>(initialModalState)

export const categoryModalAtom = atom(
  (get) => get(modalAtom).categoryModal,
  (get, set, update: Partial<ModalState['categoryModal']>) => {
    const currentState = get(modalAtom)
    set(modalAtom, {
      ...currentState,
      categoryModal: {
        ...currentState.categoryModal,
        ...update
      }
    })
  }
)
